import jwt_decode from "jwt-decode";
import moment from "moment";

export const findByTestAtrr = (component, attr) => {
  const wrapper = component.find(`[data-test='${attr}']`);
  return wrapper;
};

export const parsingAccessToken = () => {
  //const token = sessionStorage.getItem('msal.31e9ebe8-67ae-4528-af8b-b096cbc4f3dc.idtoken');
  const token = sessionStorage.getItem(
    "msal.75d906ea-0a1a-4c2f-b324-ae81485c8bcd.idtoken"
  );
  const decoded = jwt_decode(token);
  const userId = decoded.userId;
  const clientId = decoded.clientId;
  const clientName = decoded.clientName;

  localStorage.setItem("token", token);
  localStorage.setItem("userId", userId);
  localStorage.setItem("clientId", clientId);
  localStorage.setItem("clientName", clientName);
  console.log("token", token);
  console.log("userId", userId);
  console.log("clientId", clientId);
  console.log("clientName", clientName);
};

export const sortByOrder = (inputArr) => {
  const resultArr = new Array(inputArr.length - 1);
  inputArr.forEach((element) => {
    resultArr[element.order - 1] = element;
  });
  return resultArr;
};

export const usFormatPhoneNumber = (phoneNumberString) => {
  var number = ("" + phoneNumberString).replace(/\D/g, "");
  var match = number.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return null;
};

export const setDocumentId = (doumentId) => {
  document.body.id = doumentId;
};

export const setDateFormat = (date) => {
  const momentDate = moment.utc(date).format("MM/DD/YYYY");
  return momentDate !== "Invalid date" ? momentDate : "N/A";
};

export const setDateTimeFormat = (date) => {
  const momentDateTime = moment.utc(date).format("MM/DD/YYYY");
  return momentDateTime !== "Invalid date" ? momentDateTime : "N/A";
};

export const assignDefaultVal = (objArr, defaultVal = "N/A") => {
  return objArr.map((obj) => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && !obj[key]) obj[key] = defaultVal;
    }
    return obj;
  });
};
